import { Link } from "react-router-dom";

const Error = () => {
  return (
    <section className='section'>
      <h2>Error</h2>
      <Link to='/' >back home</Link>
    </section>
  );
};
export default Error;
